import React from 'react';
import { StyleSheet, Text } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { CalcScreen, CategoryCard } from '../../components/shell';
import { C, FONT, SP } from '../../theme/tokens';

type Calc = { title: string; description: string; screen: string };

const CALCS: Calc[] = [
  { title: 'Fan Affinity Laws', description: 'Flow, pressure, and power vs. fan speed', screen: 'FanEquationsFanAffinityLaws' },
  { title: 'Tip Speed', description: 'Blade tip speed from RPM and wheel diameter', screen: 'FanEquationsTipSpeed' },
  { title: 'RPM and PD', description: 'Sheave pitch diameter and RPM relationships', screen: 'SheaveEquationsRPMandPD' },
  { title: 'Fan Belt Length', description: 'Required belt length from sheave geometry', screen: 'SheaveEquationsFanBeltLength' },
];

export default function TABFanAffinityScreen() {
  const nav = useNavigation();
  return (
    <CalcScreen title="Fan & Sheave" subtitle="TAB · Fan equations and sheave geometry">
      <Text style={styles.sectionLabel}>Calculations</Text>
      {CALCS.map((c) => (
        <CategoryCard
          key={c.screen}
          title={c.title}
          description={c.description}
          cta="Open →"
          onPress={() => nav.navigate(c.screen as never)}
        />
      ))}
    </CalcScreen>
  );
}

const styles = StyleSheet.create({
  sectionLabel: {
    fontFamily: FONT.sans,
    fontSize: 12,
    color: C.dim,
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    marginBottom: SP.sm,
  },
});
